import { useCallback, useState } from 'react';
import type { LaboratoryStroageData } from '../../../native-module';

// useLaboratorySetting.ts 의 DEFAULT_VALUES 와 sync 필요
const DEFAULT_VALUES: Record<keyof LaboratoryStroageData, boolean> = {
  IS_TOUCH_VIBRATION: false,
  IS_LIKE_FOLDER: true,
  IS_GIF_IMAGE: true,
  IS_SELECT_GOODS_SCREEN_SHOT_SHARE: true,
};

export const useLaboratorySetting = (key: keyof LaboratoryStroageData) => {
  const [isOn, setIsOn] = useState<boolean | undefined>(undefined);
  const loadValue = useCallback(
    async (): Promise<boolean> => DEFAULT_VALUES[key],
    [key],
  );
  console.log(
    `useLaboratorySetting called with key: ${key}, but it's a no-op on web.`,
  );
  return { isOn, setIsOn, loadValue };
};
